import React from 'react';
import { useSelector } from 'react-redux';

import { Flex, Select, Input, Typography } from 'antd';
import FileUpload from '../../../../../../components/FileUpload';

const { Text } = Typography;

export const TableCol = (action, status) => {
  const _static = useSelector((state) => state.static);
  const { staticData } = _static;
  const { events } = staticData;

  return [
    {
      key: 'event',
      dataIndex: 'event',
      title: 'Event/s',
      render: (value, row) => {
        const _events = events.filter((item) => item.id === value);
        const _event = _events[0];

        return (
          <Select
            style={{ width: '300px', minHeight: '64px' }}
            disabled={status === 1 || status === 2 || status === 3}
            options={[
              ...events.map((event) => ({
                value: event.id,
                label: (
                  <Flex vertical>
                    <Text>{event?.name}</Text>
                    <Text type="secondary">({event?.point} APA Points)</Text>
                  </Flex>
                )
              }))
            ]}
            defaultValue={_event.id}
            placeholder="Select a Event"
            onChange={(e) => action({ ...row, event: e })}
          />
        );
      }
    },
    {
      key: 'detail',
      dataIndex: 'detail',
      title: 'Details',
      render: (value, row) => (
        <Input
          placeholder="Enter"
          value={value}
          disabled={status === 1 || status === 2 || status === 3}
          onChange={(e) => action({ ...row, detail: e.target.value })}
        />
      )
    },
    {
      key: 'upload',
      dataIndex: 'attachment',
      title: 'Attachments',
      render: (fileList, row) => (
        <FileUpload
          fileList={fileList}
          row={row}
          action={action}
          disabled={status === 1 || status === 2 || status === 3}
          status={status}
          isMandatory={true}
        />
      )
    },
    {
      key: 'apa_point',
      dataIndex: 'apa_point',
      title: 'APA Point'
    }
  ];
};
